import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Subscription} from "rxjs";
import { first } from 'rxjs/operators'
import {AuthApiService} from "../../../shared/core-jpats/services/auth.service";
import {PatientHomeService} from "../shared/services/patient-home.service";
import {RegisterIncomingComponent} from "./register-incoming/register-incoming.component";
import {UserManagementService} from "../../../shared/core-jpats/services/user-management.service";
import {DatetimeService} from "../../../shared/services/datetime.service";

@Component({
  selector: 'last-incoming-patients',
  templateUrl: './last-incoming-patients.component.html',
  styleUrls: ['./last-incoming-patients.component.scss']
})
export class LastIncomingPatientsComponent implements OnInit {
  @ViewChild("barcode") barcodeInput;

  authSubscription: Subscription;
  locationChangedSub: Subscription;
  tableData: any[] = [];
  filteredData: any[] = [];
  firstItem: number = 0;
  pageSize: number = 10;
  bsModalRef: BsModalRef;

  currentFcc = null;
  currentLocation = null;
  currentOperation = null;
  get canEdit() {
    return !!(this.currentFcc?.active && this.currentLocation?.active && this.currentOperation?.active);
  }

  constructor(
    private authApiService: AuthApiService,
    private _modalService: BsModalService,
    private userManagementService: UserManagementService,
    private patientService: PatientHomeService,
    public dateTimeService:DatetimeService) { }

  ngOnInit() {
    this.authSubscription = this.authApiService.authFinished.subscribe((res)=>{
      this.getIncomingPatients();
      this.getCurrentLocation();
    });
    this.locationChangedSub = this.userManagementService.locationChanged.subscribe((data)=>{
      this.getIncomingPatients();
      this.getCurrentLocation();
    });
    if(this.authApiService.hasAuthenticated() &&  this.authApiService.getToken()){
      this.getIncomingPatients();
      this.getCurrentLocation();
    }
  }
  getIncomingPatients(){
    this.patientService.getIncomingPatients().subscribe((res)=>{
      this.tableData = res || [];
      this.filteredData = this.tableData;
    });
  }

  getCurrentLocation() {
    this.userManagementService.getCurrentUser().subscribe((userData) => {
      if (userData.fcc) this.currentFcc = userData.fcc;
      if (userData.location) this.currentLocation = userData.location;
      if (userData.operation) this.currentOperation = userData.operation;
    });
  }

  searchPatients(e){
    this.filteredData = this.tableData.filter((item)=>{
      return item.lastNameFirst.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 || item.identifiers.find(i => i.identifierNumber.indexOf(e.target.value.toLowerCase()) > - 1);
    });
  }
  registerPatient(patientKey, patientName, event?) {
    let activeElement = document.activeElement;
    let pointerType = event ? event.pointerType : '';

    this.bsModalRef = this._modalService.show(RegisterIncomingComponent, {class: 'modal-lg', ignoreBackdropClick: true });
    this.bsModalRef.content.patientKey =patientKey;
    this.bsModalRef.content.patientName = patientName;

    this.bsModalRef.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (pointerType == "mouse") activeElement.blur();
      }
    });
    this.bsModalRef.content.complete.subscribe(result => {
      this.barcodeInput.nativeElement.value = '';
      this.filteredData = this.tableData;
      this.patientService.registerPatientAtLocation(result).subscribe((saved)=>{
        this.getIncomingPatients();
      });
    });
  }
  ngOnDestroy(){
    this.authSubscription.unsubscribe();
  }
}
